import { Grid } from '@mui/material';
import { SemiCircle } from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import styles from './overall-sentiment.module.scss';

/* eslint-disable-next-line */
export interface OverallSentimentProps {}

/**
 * Component to render overall sentimnet for contact in grpahical view
 * @param param0 - OverallSentimentProps
 * @example - <OverallSentiment />
 * @returns
 */
export function OverallSentiment(props?: any) {
  return (
    <>
      <Grid container spacing={0} className={styles['overall-sentiment']}>
        <div className="sentiment-header">Contact Sentiment </div>
      </Grid>
      <Grid
        container
        spacing={0}
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '10px',
          height: '100px',
        }}
      >
        <SemiCircle
          radius={props.radius}
          imageSrc={props.imageSrc}
          percentage={props.percentage}
          imageSize="2.5rem"
          rangeOfMetricClass={props.rangeOfMetricClass}
          scale={1.25}
        ></SemiCircle>
      </Grid>
    </>
  );
}

export default OverallSentiment;
